/**
 * @flow
 * @relayHash 3a62652310999bfb76d7627d3e660980
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type srcStoreDetailQueryVariables = {|
  slug: string
|};
export type srcStoreDetailQueryResponse = {|
  +store: ?{|
    +name: string,
    +color: ?string,
    +uid: string,
    +slug: string,
    +details: ?{|
      +cover: ?string,
      +description: ?$ReadOnlyArray<?{|
        +type: ?string,
        +text: ?string,
        +spans: $ReadOnlyArray<{|
          +start: number,
          +end: number,
          +type: string,
          +data: ?{|
            +id: ?string,
            +uid: ?string,
            +url: ?string,
            +type: ?string,
            +slug: ?string,
            +link_type: ?string,
          |},
        |}>,
      |}>,
      +video: ?string,
      +phone: ?string,
      +email: ?string,
      +operatinghours: ?string,
      +gallery: ?$ReadOnlyArray<?string>,
    |},
    +seo: ?{|
      +title: ?string,
      +description: ?string,
    |},
    +social: ?{|
      +generic: ?$ReadOnlyArray<?{|
        +title: ?string,
        +description: ?string,
        +image: ?string,
      |}>,
      +twitter: ?$ReadOnlyArray<?{|
        +type: ?string,
        +title: ?string,
        +description: ?string,
        +handle: ?string,
        +image: ?string,
      |}>,
    |},
    +preview: ?{|
      +address: ?string
    |},
    +products: $ReadOnlyArray<?{|
      +picture: ?string,
      +name: ?string,
      +description: ?string,
      +type: ?string,
      +link: ?string,
    |}>,
    +structured_data: ?{|
      +street_address: ?string,
      +address_locality: ?string,
      +postal_code: ?string,
      +address_country: ?string,
      +same_as: ?string,
      +price_range: ?string,
      +geo: ?{|
        +latitude: ?string,
        +longitude: ?string,
      |},
      +openingHours: ?$ReadOnlyArray<?{|
        +open: ?string,
        +close: ?string,
        +days_of_week: ?$ReadOnlyArray<?string>,
      |}>,
    |},
  |}
|};
export type srcStoreDetailQuery = {|
  variables: srcStoreDetailQueryVariables,
  response: srcStoreDetailQueryResponse,
|};
*/


/*
query srcStoreDetailQuery(
  $slug: String!
) {
  store(slug: $slug) {
    name
    color
    uid
    slug
    details {
      cover
      description {
        type
        text
        spans {
          start
          end
          type
          data {
            id
            uid
            url
            type
            slug
            link_type
          }
        }
      }
      video
      phone
      email
      operatinghours
      gallery
    }
    seo {
      title
      description
    }
    social {
      generic {
        title
        description
        image
      }
      twitter {
        type
        title
        description
        handle
        image
      }
    }
    preview {
      address
    }
    products {
      picture
      name
      description
      type
      link
    }
    structured_data {
      street_address
      address_locality
      postal_code
      address_country
      same_as
      price_range
      geo {
        latitude
        longitude
      }
      openingHours {
        open
        close
        days_of_week
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "slug",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "uid",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
},
v8 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "store",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug",
        "type": "String!"
      }
    ],
    "concreteType": "Store",
    "plural": false,
    "selections": [
      v1,
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "color",
        "args": null,
        "storageKey": null
      },
      v2,
      v3,
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "details",
        "storageKey": null,
        "args": null,
        "concreteType": "StoreDetails",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cover",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "description",
            "storageKey": null,
            "args": null,
            "concreteType": "StoreDescription",
            "plural": true,
            "selections": [
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "text",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "spans",
                "storageKey": null,
                "args": null,
                "concreteType": "StoreDescriptionSpan",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "start",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "end",
                    "args": null,
                    "storageKey": null
                  },
                  v4,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "data",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StoreDescriptionSpanData",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "id",
                        "args": null,
                        "storageKey": null
                      },
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "url",
                        "args": null,
                        "storageKey": null
                      },
                      v4,
                      v3,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "link_type",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "video",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "phone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "operatinghours",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "gallery",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "seo",
        "storageKey": null,
        "args": null,
        "concreteType": "SEO",
        "plural": false,
        "selections": [
          v5,
          v6
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "social",
        "storageKey": null,
        "args": null,
        "concreteType": "SocialMedia",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "generic",
            "storageKey": null,
            "args": null,
            "concreteType": "GenSocialSlices",
            "plural": true,
            "selections": [
              v5,
              v6,
              v7
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "twitter",
            "storageKey": null,
            "args": null,
            "concreteType": "TwtrSlices",
            "plural": true,
            "selections": [
              v4,
              v5,
              v6,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "handle",
                "args": null,
                "storageKey": null
              },
              v7
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "preview",
        "storageKey": null,
        "args": null,
        "concreteType": "StorePreview",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "address",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "products",
        "storageKey": null,
        "args": null,
        "concreteType": "StoreProduct",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "picture",
            "args": null,
            "storageKey": null
          },
          v1,
          v6,
          v4,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "link",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "structured_data",
        "storageKey": null,
        "args": null,
        "concreteType": "StructuredData",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "street_address",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "address_locality",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "postal_code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "address_country",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "same_as",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "price_range",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "geo",
            "storageKey": null,
            "args": null,
            "concreteType": "Geolocation",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "latitude",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "longitude",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "openingHours",
            "storageKey": null,
            "args": null,
            "concreteType": "OpeningHoursSlice",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "open",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "close",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "days_of_week",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "srcStoreDetailQuery",
  "id": null,
  "text": "query srcStoreDetailQuery(\n  $slug: String!\n) {\n  store(slug: $slug) {\n    name\n    color\n    uid\n    slug\n    details {\n      cover\n      description {\n        type\n        text\n        spans {\n          start\n          end\n          type\n          data {\n            id\n            uid\n            url\n            type\n            slug\n            link_type\n          }\n        }\n      }\n      video\n      phone\n      email\n      operatinghours\n      gallery\n    }\n    seo {\n      title\n      description\n    }\n    social {\n      generic {\n        title\n        description\n        image\n      }\n      twitter {\n        type\n        title\n        description\n        handle\n        image\n      }\n    }\n    preview {\n      address\n    }\n    products {\n      picture\n      name\n      description\n      type\n      link\n    }\n    structured_data {\n      street_address\n      address_locality\n      postal_code\n      address_country\n      same_as\n      price_range\n      geo {\n        latitude\n        longitude\n      }\n      openingHours {\n        open\n        close\n        days_of_week\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "srcStoreDetailQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v8
  },
  "operation": {
    "kind": "Operation",
    "name": "srcStoreDetailQuery",
    "argumentDefinitions": v0,
    "selections": v8
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3402374f88cc38b48d19c541ccc5431d';
module.exports = node;
